import $ from "jquery";
import d3 from "d3";
import gettext from "../shared/utils/gettext";
import cropr from "../shared/utils/cropr";

const _pgettext = window.pgettext || ((_part, string) => string);

export { gettext, cropr, $, d3 };
export const pgettext = _pgettext;
